import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Btn } from "@/components/common";
import { Target } from "lucide-react";

export default function TargetQuick({ year, target, onSaved }) {
  const [v, setV] = useState(target.amount ?? "");
  useEffect(() => { setV(target.amount ?? ""); }, [target.amount]);
  const save = async () => {
    try {
      await api.put(`/previsionale/${year}/target`, { amount: v === "" ? null : Number(v), peso_alta: Number(target.peso_alta) || 2, mesi_alta: target.mesi_alta });
      toast.success(v === "" ? "Obiettivo rimosso" : "Obiettivo salvato");
      onSaved();
    } catch (e) { toast.error("Valore non valido"); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-md border border-sky-200 bg-sky-50/60 px-3 py-2" data-testid="pv-target-quick">
      <Target size={16} className="text-sky-700" />
      <span className="text-sm font-semibold text-slate-700">Obiettivo netto {year}</span>
      <input data-testid="pv-target-quick-input" type="number" min="0" value={v} onChange={(e) => setV(e.target.value)} placeholder="es. 200000"
        className="w-36 px-2 py-1.5 text-sm text-right rounded-md border border-slate-300 bg-white" />
      <span className="text-sm text-slate-500">€</span>
      <Btn data-testid="pv-target-quick-save" onClick={save}>Salva</Btn>
      <span className="text-[11px] text-slate-400">vuoto = nessun obiettivo · diviso sui mesi aperti secondo i pesi di stagione</span>
    </div>
  );
}
